import { useLoaderData } from "react-router";
import CustomError from "@components/Error/CustomError";
import { MetaTagDescriptor } from "@components/MetaTags/MetaTags";
import { type Route } from "@route-types/Home/+types/HomePage";
import { fetchHomePageData } from "@routes/Home/HomePage.server";
import HomePageContent from "@routes/Home/HomePageContent";
import { HomePageContext } from "@routes/Home/utils/types";
import { ResponseType } from "@sphtech/web2-core/ssr";
import { HttpStatusCode } from "axios";

/** This is the entry component for the / page route. */
const HomePage = (): React.ReactElement => {
  const context = useLoaderData<HomePageContext>();

  // StatusCode is not 200
  if (context && context.statusCode !== HttpStatusCode.Ok) {
    return <CustomError statusCode={context.statusCode} />;
  }

  // Check if payload is missing
  if (typeof context?.payload === "undefined") {
    return <CustomError statusCode={HttpStatusCode.NotFound} />;
  }

  return <HomePageContent {...context.payload.data} />;
};

export default HomePage;

export const loader = async () => await fetchHomePageData();

export const meta = ({ loaderData }: Route.MetaArgs): MetaTagDescriptor[] => {
  const context = loaderData as HomePageContext;
  if (context.type !== ResponseType.SUCCESS) return [];

  const data = context.payload;

  if (!data) return [];
  if (!data.metaTags) return [];

  return data.metaTags;
};
